<div class="dashboard-content-sec " id="user_edit">
    <div class="loader" *ngIf="showloader">
        <img src="assets/images/loader.gif" alt="">
    </div>

 

    <form (ngSubmit)="saveRoleProfile()" [formGroup]="form">        

        <div class="row form-section">
            <div class="col">
                <div class="card">
                    <app-breadcrumb *ngIf="!embedded" [crumbList]="crumbList"></app-breadcrumb>

                    <div class="card-title">
                        <h5 class="fa fa-user">
                            {{ this.title }}
                        </h5>
                        <div class="float-right">
                            <button type="submit" class="btn btn-default align-items-end" tabindex="8">Submit</button>
                        </div>                        
                    </div>

                    <div class="card-form">

                        <div *ngIf="submitted && this.form.invalid" class="invalid-feedback">
                            <span >Please review for the form for invalid fields</span>
                        </div>
    
                        <div *ngIf="this.successful_result"
                            class="alert alert-success" role="alert">
                            Successfully saved record
                        </div>
                        <div *ngIf="this.error_result" class="alert alert-danger" role="alert">
                            Unable to save record. Error occurred.
                        </div>
            
                        <div class="form-row">
                            <label class="col-sm-2">Role Name</label>                                    
                            <div class="form-group col-sm-4">
                                <input formControlName="Name"
                                    name="Name" type="text" 
                                    required minlength="2"
                                    class="form-control" 
                                    tabindex="1" placeholder="">                                    
                            </div>
                            <div class="col-sm-1">
                                &nbsp;
                            </div>
                        </div>

                        <div *ngIf="NameCtrl.invalid && (NameCtrl.dirty || NameCtrl.touched)"
                            class="invalid-feedback">
                           <div *ngIf="NameCtrl.errors.required">
                              <span>Name is required.</span>
                           </div>
                           <div *ngIf="NameCtrl.errors.minlength">
                              Name must be at least 2 characters long.
                           </div>
                        </div>
       
                           
                        <div class="form-row" *ngIf="!embedded">
                            <label class='col-sm-2'>Role Type</label>
                            <div class='form-group col-sm-4'>
                                <select name="Role" class="form-control" formControlName="Role" 
                                    tabindex="2" (change)="updateAuths()">
                                    <!-- <option selected value="">Please select Client</option> -->
                                    <option id="{{utype.RoleType}}" value="{{utype.RoleType}}" 
                                            *ngFor="let utype of RoleTypes">{{utype.RoleName}}
                                    </option>

                                </select>

                                <div *ngIf="RoleCtrl.invalid && (RoleeCtrl.dirty || RoleCtrl.touched)"
                                    class="invalid-feedback">
                                    <div>
                                        <span>Role Type is required.</span>
                                    </div>
                                </div>        
                            </div>
                        </div>

                        <div class="form-row" *ngIf="!embedded &&
                                                    (form.controls.Role.value === '2' || 
                                                     form.controls.Role.value === 2)">
                            <label class='col-sm-2'>Client</label>
                            <div class='form-group col-sm-4'>
                                <select name="ClientID" class="form-control" formControlName="ClientID" tabindex="3">
                                    <option id="{{client.ID}}" value="{{client.ID}}" 
                                            *ngFor="let client of clients">{{client.ClientName}}
                                    </option>

                                </select>

                                <div *ngIf="ClientIDCtrl.invalid && (ClientIDCtrl.dirty || ClientIDCtrl.touched)"
                                    class="invalid-feedback">
                                    <div>
                                        <span>Client is required.</span>
                                    </div>
                                </div>        
                            </div>
                        </div>

                        <div class="form-row" *ngIf="(form.controls.Role.value === 3 ||
                                                      form.controls.Role.value === '3') &&
                                                      !embedded">
                            <label class='col-sm-2'>Partner</label>
                            <div class='form-group col-sm-4'>
                                <select name="PartnerID" class="form-control" formControlName="PartnerID" tabindex="3">
                                    <option id="{{partner.ID}}" value="{{partner.ID}}" 
                                            *ngFor="let partner of partners">{{partner.CompanyName}}
                                    </option>

                                </select>

                                <div *ngIf="PartnerIDCtrl.invalid && (PartnerIDCtrl.dirty || PartnerIDCtrl.touched)"
                                    class="invalid-feedback">
                                    <div>
                                        <span>Partner is required.</span>
                                    </div>
                                </div>        
                            </div>
                        </div>

                        <div class="form-row">
                            <label class="col-sm-2 control-label">Full Access</label>
                            <div class="form-group col-sm-4">
                                <label class="switch">
                                    <input type="checkbox" (change)="toggleChange($event)" [checked]="fullAccess == 'Yes'" >
                                    <span class="slider"></span>
                                </label>
                                <label class="col-sm-3" id="activeLabel">{{fullAccess}}</label>
                            </div>
                        </div>

                        <div class="form-row" *ngIf="isAttorneyProfile()">
                            <label class="col-sm-2 control-label">Restricted Access</label>
                            <div class="form-group col-sm-4">
                                <label class="switch">
                                    <input type="checkbox" (change)="toggleRestrictedChange($event)" [checked]="restrictedAccess == 'Yes'" >
                                    <span class="slider"></span>
                                </label>
                                <label class="col-sm-3" id="restrictedActiveLabel">{{restrictedAccess}}</label>
                            </div>
                        </div>



                        <div class="form-row mt-3" style="padding-left: 10px">
                            <div class="form-row">
                                <label>Authorizations</label>
                            </div>

                            <div class="table-responsive">
                                <table id="authTable" class="table user-table table-striped">
                                    <thead>
                                            <th >Description</th>
                                            <th >Access</th>
                                    </thead>
                    
                                    <tbody>
                                        <ng-container *ngFor="let auth of authList">
                                            <tr id="auth-row{{auth.ID}}">
                                                <td>
                                                    <span>{{auth.Description}}</span>                                                    
                                                </td>
                                                
                                                <td>
                                                    
                                                    <select id="auth_{{roleprofile_id}}_{{auth.ID}}"  class="custom-select" style="width: 100px" 
                                                        (change)="saveStatus(auth.ID)"
                                                        [disabled]="form.value.FullAccess"> 
                                                        <option value="1"
                                                             [selected]="auth.Status == 1">Yes
                                                        </option>
                                                        <option value="0"
                                                             [selected]="auth.Status == 0">No
                                                        </option>
                                                   </select>
                                                </td>
                                           
                                            </tr>
                                        </ng-container>
                                        
                                    </tbody>                   
               
                                </table>                      
                            </div>
                        </div>
                       







                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
      


